import React from "react";
import { Link } from "react-router-dom";
import styles from "./HeroTagline.module.scss";

import EasterImg from "images/Promotions/Easter15.png";

const HeroTagline = () => {
    return (
        <section className={styles.heroTagline}>
            <div className={styles.titleBlock}>
                <img src={EasterImg} alt="" className={`${styles.avatar} ${styles.avatarLeft}`} />
                <img src={EasterImg} alt="" className={`${styles.avatar} ${styles.avatarRight}`} />
                <h1 className={styles.heading}>
                    TURN <span className={styles.highlight}>YOUR TV</span> INTO
                    <br />
                    A GAME SHOW!
                </h1>
                <p className={styles.subtitle}>Everyone plays from their phone</p>
                <p className={styles.subSubtitle}>
                    Buy once. Unlimited play. <span className={styles.underline}>No subscriptions.</span>
                </p>
                <p className={styles.promoTitle}>USE CODE <span className={styles.promoCode}>EASTER15</span> FOR 15% OFF</p>
                <Link to="/shop" className={styles.shopNowButton}>SHOP NOW</Link>
            </div>
        </section>
    );
};

export default HeroTagline;
